import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';

import {
  getTransactionsOrderSalseById,
  cleanUpTransactionsOrderSalseById,
} from '../../store/Sales/SalesOrder/SalesOrderSlice';

interface Props {
  id: string | undefined;
}

const useGetSellOrderById = ({ id }: Props) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (id) {
      dispatch(getTransactionsOrderSalseById(id));
    }

    return () => {
      dispatch(cleanUpTransactionsOrderSalseById());
    };
  }, [dispatch, id]);
  const { TransactionsSalesOrderById, loading, error } = useAppSelector((state) => state.SalesOrder);

  return { TransactionsSalesOrderById, loading, error };
};

export default useGetSellOrderById;
